import stadAntwerpenLogo from "../assets/images/stad_antwerpen.png";
import treeCompanyLogo from "../assets/images/treecompany_logo.png";
import translate from "../locales";

export default function Footer() {
  return (
    <footer className="page-footer">
      <div className="page-footer__row">
        <a
          href="https://www.antwerpen.be/nl/overzicht/district-antwerpen-1"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={stadAntwerpenLogo}
            alt={translate("footer.stad_antwerpen_alt")}
            className="page-footer__logo"
            loading="lazy"
          />
        </a>
        <a href="https://www.treecompany.be" target="_blank" rel="noreferrer">
          <img
            src={treeCompanyLogo}
            alt={translate("footer.tree_company_alt")}
            className="page-footer__logo"
            loading="lazy"
          />
        </a>
      </div>
      <div className="page-footer__link-row">
        <a
          href="https://burgerbegroting.be/privacy"
          className="page-footer__link"
          target="_blank"
          rel="noreferrer"
        >
          {translate("rrn.privacy")}
        </a>
      </div>
    </footer>
  );
}
